export enum ListViewTypes {
  table = 'table',
  cards = 'cards',
  template = 'template',
}
